const sharedScale = {
  radiusShell: "20px",
  radiusPanel: "16px",
  radiusControl: "12px",
  radiusPill: "999px",
  shadowSoft: "0 10px 24px rgba(19, 39, 57, 0.07)",
  shadowPanel: "0 16px 36px rgba(19, 39, 57, 0.09)",
  shadowStrong: "0 22px 48px rgba(19, 39, 57, 0.12)",
  spacingPage: "16px",
  spacingPanel: "20px",
};

const familyThemes = {
  applicant: {
    day: {
      canvas: "#f4f6f7",
      rail: "rgba(250, 251, 252, 0.98)",
      surface: "rgba(255, 255, 255, 0.97)",
      surfaceElevated: "#fbfcfc",
      surfaceMuted: "#f1f4f6",
      border: "rgba(184, 194, 204, 0.82)",
      borderStrong: "rgba(144, 159, 175, 0.9)",
      textPrimary: "#182531",
      textSecondary: "#5f6c79",
      textTertiary: "#7b8795",
      primarySignal: "#22506b",
      primarySoft: "rgba(34, 80, 107, 0.1)",
      success: "#236646",
      successSoft: "rgba(35, 102, 70, 0.12)",
      warning: "#9a6700",
      warningSoft: "rgba(154, 103, 0, 0.12)",
      danger: "#b42318",
      dangerSoft: "rgba(180, 35, 24, 0.12)",
      info: "#175cd3",
      infoSoft: "rgba(23, 92, 211, 0.12)",
      heroGlow:
        "linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(245, 248, 250, 0.98))",
      canvasGlow:
        "linear-gradient(180deg, #f6f7f8 0%, #eff3f5 48%, #f4f6f7 100%)",
    },
    night: {
      canvas: "#0a1730",
      rail: "rgba(9, 23, 46, 0.96)",
      surface: "rgba(10, 24, 48, 0.94)",
      surfaceElevated: "#0d284f",
      surfaceMuted: "#0d2242",
      border: "rgba(53, 92, 153, 0.76)",
      borderStrong: "rgba(75, 121, 193, 0.88)",
      textPrimary: "#eef5ff",
      textSecondary: "#9fb2ce",
      textTertiary: "#7f96b7",
      primarySignal: "#6e9dff",
      primarySoft: "rgba(110, 157, 255, 0.18)",
      success: "#50c38d",
      successSoft: "rgba(80, 195, 141, 0.18)",
      warning: "#efb34f",
      warningSoft: "rgba(239, 179, 79, 0.18)",
      danger: "#ff7d8c",
      dangerSoft: "rgba(255, 125, 140, 0.18)",
      info: "#67cde9",
      infoSoft: "rgba(103, 205, 233, 0.18)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(47, 168, 224, 0.26), transparent 26%), linear-gradient(120deg, rgba(8, 23, 46, 0.95), rgba(11, 32, 61, 0.92) 76%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(67, 108, 194, 0.28), transparent 26%), radial-gradient(circle at top right, rgba(41, 132, 173, 0.26), transparent 30%), linear-gradient(180deg, #071325 0%, #0b1d37 50%, #0d213d 100%)",
    },
  },
  admin: {
    day: {
      canvas: "#f3f5f6",
      rail: "rgba(249, 250, 251, 0.98)",
      surface: "rgba(255, 255, 255, 0.97)",
      surfaceElevated: "#fafbfc",
      surfaceMuted: "#f0f3f5",
      border: "rgba(181, 192, 202, 0.82)",
      borderStrong: "rgba(143, 157, 171, 0.9)",
      textPrimary: "#182531",
      textSecondary: "#5e6b78",
      textTertiary: "#7b8895",
      primarySignal: "#214e67",
      primarySoft: "rgba(33, 78, 103, 0.1)",
      success: "#21684a",
      successSoft: "rgba(33, 104, 74, 0.12)",
      warning: "#9a6700",
      warningSoft: "rgba(154, 103, 0, 0.12)",
      danger: "#b42318",
      dangerSoft: "rgba(180, 35, 24, 0.12)",
      info: "#175cd3",
      infoSoft: "rgba(23, 92, 211, 0.12)",
      heroGlow:
        "linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(245, 247, 249, 0.98))",
      canvasGlow:
        "linear-gradient(180deg, #f6f7f8 0%, #eef2f4 52%, #f3f5f6 100%)",
    },
    night: {
      canvas: "#081425",
      rail: "rgba(9, 21, 38, 0.97)",
      surface: "rgba(11, 25, 45, 0.96)",
      surfaceElevated: "#0d2849",
      surfaceMuted: "#0a1f3c",
      border: "rgba(47, 82, 132, 0.72)",
      borderStrong: "rgba(72, 112, 176, 0.86)",
      textPrimary: "#eef4ff",
      textSecondary: "#9ab0cf",
      textTertiary: "#7992b4",
      primarySignal: "#6f97ff",
      primarySoft: "rgba(111, 151, 255, 0.18)",
      success: "#4fc28b",
      successSoft: "rgba(79, 194, 139, 0.18)",
      warning: "#f1b24b",
      warningSoft: "rgba(241, 178, 75, 0.18)",
      danger: "#ff7586",
      dangerSoft: "rgba(255, 117, 134, 0.18)",
      info: "#5fc7e5",
      infoSoft: "rgba(95, 199, 229, 0.18)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(49, 115, 214, 0.24), transparent 28%), linear-gradient(128deg, rgba(8, 21, 40, 0.96), rgba(10, 29, 54, 0.94) 74%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(44, 77, 133, 0.24), transparent 24%), radial-gradient(circle at top right, rgba(27, 122, 162, 0.22), transparent 28%), linear-gradient(180deg, #081425 0%, #0a1930 52%, #081425 100%)",
    },
  },
  employer: {
    day: {
      canvas: "#f4f6f6",
      rail: "rgba(249, 251, 251, 0.98)",
      surface: "rgba(255, 255, 255, 0.97)",
      surfaceElevated: "#fafbfb",
      surfaceMuted: "#f1f4f4",
      border: "rgba(181, 194, 193, 0.82)",
      borderStrong: "rgba(144, 160, 158, 0.9)",
      textPrimary: "#182829",
      textSecondary: "#5f7173",
      textTertiary: "#7b8d8f",
      primarySignal: "#295d61",
      primarySoft: "rgba(41, 93, 97, 0.1)",
      success: "#21684a",
      successSoft: "rgba(33, 104, 74, 0.12)",
      warning: "#9a6700",
      warningSoft: "rgba(154, 103, 0, 0.12)",
      danger: "#b42318",
      dangerSoft: "rgba(180, 35, 24, 0.12)",
      info: "#175cd3",
      infoSoft: "rgba(23, 92, 211, 0.12)",
      heroGlow:
        "linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(244, 247, 247, 0.98))",
      canvasGlow:
        "linear-gradient(180deg, #f6f7f7 0%, #eef2f2 52%, #f4f6f6 100%)",
    },
    night: {
      canvas: "#071918",
      rail: "rgba(8, 27, 26, 0.97)",
      surface: "rgba(10, 33, 32, 0.96)",
      surfaceElevated: "#103d3b",
      surfaceMuted: "#0b2a29",
      border: "rgba(55, 109, 105, 0.72)",
      borderStrong: "rgba(74, 142, 136, 0.86)",
      textPrimary: "#ecf8f6",
      textSecondary: "#9bb8b4",
      textTertiary: "#7d9d99",
      primarySignal: "#57b6ae",
      primarySoft: "rgba(87, 182, 174, 0.18)",
      success: "#5bc992",
      successSoft: "rgba(91, 201, 146, 0.18)",
      warning: "#e4b661",
      warningSoft: "rgba(228, 182, 97, 0.18)",
      danger: "#ff7c85",
      dangerSoft: "rgba(255, 124, 133, 0.18)",
      info: "#66cde9",
      infoSoft: "rgba(102, 205, 233, 0.18)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(63, 167, 157, 0.24), transparent 28%), linear-gradient(128deg, rgba(7, 25, 24, 0.96), rgba(10, 38, 36, 0.94) 74%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(34, 108, 104, 0.24), transparent 24%), radial-gradient(circle at top right, rgba(27, 127, 151, 0.22), transparent 28%), linear-gradient(180deg, #071918 0%, #0a2221 52%, #071918 100%)",
    },
  },
};

export function getDashboardThemeTokens({ family = "admin", appearance = "day" } = {}) {
  const familyToken = familyThemes[family] || familyThemes.admin;
  const appearanceToken = familyToken[appearance] || familyToken.day;
  return {
    ...sharedScale,
    ...appearanceToken,
  };
}

export function getDashboardCssVariables(options = {}) {
  const token = getDashboardThemeTokens(options);
  return {
    "--dashboard-canvas": token.canvas,
    "--dashboard-canvas-glow": token.canvasGlow,
    "--dashboard-rail": token.rail,
    "--dashboard-surface": token.surface,
    "--dashboard-surface-elevated": token.surfaceElevated,
    "--dashboard-surface-muted": token.surfaceMuted,
    "--dashboard-border": token.border,
    "--dashboard-border-strong": token.borderStrong,
    "--dashboard-text-primary": token.textPrimary,
    "--dashboard-text-secondary": token.textSecondary,
    "--dashboard-text-tertiary": token.textTertiary,
    "--dashboard-primary": token.primarySignal,
    "--dashboard-primary-soft": token.primarySoft,
    "--dashboard-success": token.success,
    "--dashboard-success-soft": token.successSoft,
    "--dashboard-warning": token.warning,
    "--dashboard-warning-soft": token.warningSoft,
    "--dashboard-danger": token.danger,
    "--dashboard-danger-soft": token.dangerSoft,
    "--dashboard-info": token.info,
    "--dashboard-info-soft": token.infoSoft,
    "--dashboard-hero": token.heroGlow,
    "--dashboard-shadow-soft": token.shadowSoft,
    "--dashboard-shadow-panel": token.shadowPanel,
    "--dashboard-shadow-strong": token.shadowStrong,
    "--dashboard-radius-shell": token.radiusShell,
    "--dashboard-radius-panel": token.radiusPanel,
    "--dashboard-radius-control": token.radiusControl,
    "--dashboard-radius-pill": token.radiusPill,
    "--dashboard-spacing-page": token.spacingPage,
    "--dashboard-spacing-panel": token.spacingPanel,
  };
}
